import HeaderComponent from '@common/components/headerDinamicos/headerInformacao';
import DDados from '../redeSIM.ddados';
import Form from "@common/externos/components/validation/form.validation";
import React, { Component, Fragment } from 'react';
import { connect } from '@common/components/base.component';
import autoBind from 'react-autobind';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const { selector, title, prefix } = this.props;
    const Campos = DDados.Campos;
    const nameProperDDados = Object.getOwnPropertyNames(Campos);

    return (
      <Form prefix={prefix} title={title}>
        <HeaderComponent
          panelTitle=""
          isView={true}
          ddados={Campos}
          campos={nameProperDDados}
          stateSelector={selector}
        />
      </Form>
    );
  }
}

export default connect()(Container);
